import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getOutstandingNotificationsByDay } from '../../api/notificationAPI';

const NotificationsOutstandingChart = () => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const stats = await getOutstandingNotificationsByDay();
      if (!stats) return;

      const dates = stats.map(item => item.date);
      const counts = stats.map(item => item.outstanding);

      setChartSeries([{ name: 'Outstanding', data: counts }]);
      setChartOptions({
        chart: { type: 'bar', toolbar: { show: false } },
        xaxis: { categories: dates, labels: { style: { fontSize: '14px' } } },
        yaxis: { labels: { style: { fontSize: '14px' } } },
        grid: { borderColor: '#D1D5DB', strokeDashArray: 1 },
        colors: ['#144BD6'],
      });
    };

    fetchData();
  }, []);

  return (
    <div className="col-xxl-8">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24 mb-8">
          <h6 className="mb-4 fw-bold text-lg">Outstanding Notifications By Day</h6>
          <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={300} width="100%" />
        </div>
      </div>
    </div>
  );
};

export default NotificationsOutstandingChart;
